// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPage":"privacyPolicy_PrivacyPage__17uXe","Privacy":"privacyPolicy_Privacy__1fzKo"};